<script>
  import { createEventDispatcher } from "svelte";
  import { DialogNew, notifications } from "@shopboxai/sb-portal-components";
  import { createToken } from "../../api";
  import { clientWebsite } from "../../stores";

  export let data = {};
  const dispatch = createEventDispatcher();
  const sumbitCreate = async () => {
    try {
      notifications.info("Generating token...", 2000);
      await createToken(data.name, $clientWebsite);
      notifications.success("Token generated", 2000);
    } catch (error) {
      notifications.danger("Soemthing went wrong", 2000);
    } finally {
      dispatch("complete");
    }
  };

  const tomorrow = () => {
    const today = new Date();
    today.setDate(today.getDate() + 1);
    return today.toISOString().slice(0, 10);
  };
</script>

<DialogNew on:submit={sumbitCreate} on:close>
  <button class="secondary" slot="toggle"> + Generate new API tokens </button>
  <div slot="header">Generate API token</div>
  <button class="primary" slot="primary-action"> Generate </button>
  <div slot="content">
    <label for="name">Name </label>
    <input id="name" type="text" bind:value={data.name} required />
    <input
      type="date"
      id="date"
      name="date"
      min={tomorrow()}
      bind:value={data.expiry}
    />
  </div>
</DialogNew>

<style>.secondary{background:none;border:none;color:#3a4bc4;cursor:pointer;font-size:14px;font-weight:400;letter-spacing:.4px;line-height:18px;-webkit-text-decoration-line:underline;text-decoration-line:underline}</style>
